import React, { useEffect, useState, useMemo } from 'react'
import { useKehuListQuery } from '../../store/DianShangYeWuApi';   
import {  Form, Select, Space} from 'antd';
import ClientAddIcon from '../../system/client/ClientAddIcon';
import ClientCheckIcon from '../../system/client/ClientCheckIcon';
function ClientSelect(props) {    
    const [list,setList] = useState();
    const [hasFetched, setHasFetched] = useState(false);
    const [open, setOpen] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    // 使用 Form.useWatch 监听表单字段值，而不是依赖 props.value
    const selectedValue = Form.useWatch(props.name);
    
    // 合并常用客户到 options 中，常用客户放在最前面，后面的数据过滤掉常用客户
    const mergedOptions = useMemo(() => {
        const baseList = (list || []).filter(item => item && item.value != null && item.value !== '');
        const commonList = (props.list || []).filter(item => item && item.value != null && item.value !== '');
        
        // 创建一个 Map，用于快速查找 baseList 中的完整信息
        const baseListMap = new Map();
        baseList.forEach(item => {
            baseListMap.set(item.value, item);
        });
        
        // 获取常用客户的 value 集合，用于过滤
        const commonValues = new Set(commonList.map(item => item.value));
        
        // 格式化常用客户列表，如果常用客户中缺少 kh_type_id 或 kh_type_name，从 baseList 中补充
        const formattedCommonList = commonList.map(item => {
            const baseItem = baseListMap.get(item.value);
            return {
                value: item.value,
                label: item.label,
                key: item.value,
                // 优先使用常用客户中的字段，如果没有则从 baseList 中获取
                kh_type_id: item.kh_type_id ?? baseItem?.kh_type_id ?? '',
                kh_type_name: item.kh_type_name ?? baseItem?.kh_type_name ?? ''
            };
        });
        
        // 从 baseList 中过滤掉常用客户（避免重复）
        const filteredBaseList = baseList.filter(item => !commonValues.has(item.value));
        
        // 常用客户放在最前面，后面是过滤后的 baseList
        return [...formattedCommonList, ...filteredBaseList];
    }, [list, props.list]);
    const {data,isSuccess,refetch} = useKehuListQuery(
        {kh_qy_id:props.qy_id,kh_name:searchValue,kh_remark:'',kh_type_id:''},{refetchOnMountOrArgChange:1}
    )
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                const newArr = data.Result
                    .filter(item => item && item.kh_id != null && item.kh_id !== '')
                    .map((item) => {
                        const {kh_id,kh_name,kh_type_id,kh_type_name}=item;
                        return {value:kh_id,label:kh_name,key:kh_id,kh_type_id:kh_type_id,kh_type_name:kh_type_name}
                    })
                setList(newArr)
            }
        }
    },[data,isSuccess])

    const handleOpenChange = (openState) => {
        setOpen(openState);
        if(openState && !hasFetched && props.qy_id){
            refetch();
            setHasFetched(true);
        }
    }
    return (
        <Form.Item  wrapperCol={props.wrapperCol} style={props.formStyle}>
            <Space>
                <Form.Item 
                    label={props.label} 
                    required  
                    name={props.name}
                    normalize={(value) => value === '' ? undefined : value}       
                    style={{marginBottom: 0}}
                >
                    <Select
                        options={mergedOptions} 
                        onChange={(_,f) => {
                            if(f){
                                props.onChange(f.value,f.label,f.kh_type_id,f.kh_type_name)
                            }
                        }}
                        placeholder={props.placeholder}
                        style={props.style}
                        allowClear
                        onClear={props.onClear}
                        disabled={props.disabled}
                        open={open}
                        onOpenChange={handleOpenChange}
                        showSearch
                        filterOption={false}
                        onSearch={(value) => {
                            setSearchValue(value);
                        }}
                    />
                </Form.Item>
                {props.clientAdd && <>                
                    <ClientAddIcon
                        qy_id={props.qy_id}
                        qy_name={props.qy_name}
                        yh_id={props.yh_id}
                        yh_name={props.yh_name}
                    />
                    {selectedValue && (
                        <ClientCheckIcon
                            kh_id={selectedValue}
                            kh_name={mergedOptions?.find(item => item.value === selectedValue)?.label}
                            qy_id={props.qy_id}
                            qy_name={props.qy_name}
                            yh_id={props.yh_id}
                            yh_name={props.yh_name}
                            type="button"
                        />
                    )}
                </>}
            </Space>
        </Form.Item>
    )
}

export default ClientSelect